import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { StepProps } from './AddEditTrainingVideo';

export const TrainingVideosForm = ({ touched, errors, values, setFieldValue, readOnly }: StepProps) => {
  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="Training Video Details" showRequiredLegend={!readOnly} />
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="name"
        >
          <FormLabel required>Name</FormLabel>
          <Field
            name="name"
            type="text"
            as={Form.Control}
            isInvalid={touched.name && !!errors.name}
            aria-required
          />
          <ErrorMessage name="name">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="category"
        >
          <FormLabel>Category</FormLabel>
          <Form.Control
            as="select"
            name="category"
            value={values?.category}
            onChange={(e) => setFieldValue!('category', e.target.value)}
            isInvalid={touched.category && !!errors.category}
          >
            <option>Select</option>
            <option value="training_day_1">Training day 1</option>
            <option value="training_day_2">Training day 2</option>
            <option value="training_day_3">Training day 3</option>
            <option value="classroom_management">Classroom management</option>
            <option value="cooking_skills">Cooking skills</option>
            <option value="private_parties">Private parties</option>
            <option value="summer_camp">Summer camp</option>
            <option value="food_safety">Food safety</option>
          </Form.Control>
          <ErrorMessage name="category">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="code"
        >
          <FormLabel required>Code</FormLabel>
          <Field
            name="code"
            type="text"
            as={Form.Control}
            isInvalid={touched.code && !!errors.code}
            aria-required
          />
          <ErrorMessage name="code">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>
    </Row>
  );
};
